var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"bar"},[_c('PercentageBar',{attrs:{"height":6,"preferred-direction":"MORE","tooltip":true},model:{value:(_vm.progress),callback:function ($$v) {_vm.progress=$$v},expression:"progress"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }